// extracted by mini-css-extract-plugin
export default {"sendToAppBannerContainer":"_3TlgX","title":"_1WZAw","appReviews":"_25Oxu","mobileDevicesImage":"_1cXBI","downloadCta":"_1_1Pw"};